import Cookies from 'js-cookie';

export const setToken = (data) => {
    Cookies.set('token', data.token)
    Cookies.set('refreshToken', data.refreshToken)
}

export const getToken = () => {
    let token = Cookies.get("token");
    return token;
}

export const getRefreshToken = () => {
    let token = Cookies.get("refreshToken");
    return token;
}

export const clear = () => {
    Cookies.remove('token');
    Cookies.remove('refreshToken');
    Cookies.remove('userInfo');
    localStorage.removeItem("r_token");
}

export const getInfo = () => {
    let token = getToken();
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    return token == undefined || token == "" ? {} : JSON.parse(decodeURIComponent(escape(window.atob(base64))));
}

export const isNeedRefresh = () => {
	return false;
    var info = getInfo();
    if (info && info.expiryDateTime) {
        //如果小于5分钟内过期，则刷新
        let dt1 = new Date(info.expiryDateTime);
        let dt2 = Date.now();
        let dt3 = dt1 - dt2;
        if (dt3 < 5 * 60 * 1000) {
            return true;
        }
    }
    return false;
}